import { Injectable } from '@angular/core';
import { ModalService } from './modal.service';
import { RadioModal } from '@components/radio-modal/radio-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { CancelReason } from '@interfaces/journey';
import { DriverGeoLocation } from '@interfaces/map.interface';
import { BehaviorSubject } from 'rxjs';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class JourneyService {
  driverMarker$: BehaviorSubject<DriverGeoLocation | null> = new BehaviorSubject<DriverGeoLocation | null>(null);

  constructor(private modal: ModalService,
    private translate: TranslateService,
    private rest: RestService
  ) { }

  subscribeDrivers() {
    return this.driverMarker$.asObservable();
  }

  async cancelJourney(): Promise<CancelReason | null> {
    return { reason: 'other', reasonNote: 'removed for now' };
    // TODO: Remove confirm modal with reason
    const user = await this.rest.getCurrentUser();
    if (user?.role.includes('client-hotel')) {
      return { reason: 'other', reasonNote: 'hotel' };
    } else {
      const config: RadioModal = {
        title: this.translate.instant('action_modal.cancel_journey.title'),
        selectActiveType: 'bold',
        type: 'cancel',
        data: []
      }
      config.data = [];
      const reasonList = ['changedPlans', 'longWait', 'infoIssues', 'anotherTransport', 'expensive', 'other']
      reasonList.forEach(elem => {
        config.data.push({
          text: this.translate.instant('action_modal.cancel_journey.reason_list.' + elem),
          id: elem,
          obj: { reason: elem }
        });
      });

      const result = await this.modal.openRadioModal('radio_modal', config, true);
      console.log('result', result);
      if (result?.select?.obj) {
        return result?.select?.obj;
      } else {
        return null;
      }
    }
  }

  async setPriority(id: number) {
    await this.rest.editJourney(id, { priority: true, createdAt: new Date() });
  }
}
